import React, {
    useRef,
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle,
  } from "react";
  import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
  import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
  import { getInitFormData } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
  import { showDialog } from "@widgets/CommonDialog"; // Message Box
  import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
  import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
  import SnResizable from "@shared/components/SnResizable";
  import usePanelSizes from "@shared/hooks/usePanelSizes";
  
  interface Props {
    Menuprops: menuInfo;
  }
  
  const SN_SCT_BAS_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
    //#region  variable
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRefL = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    //#endregion
  
    //#region  Components useState
    const [formData, setFormData] = useState<any>(); // 조회조건 변수
    const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
    const [columns1, setColums1] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
    const [columns2, setColums2] = useState<any[]>([]); // gridApiRefL 컬럼 설정 관련
    const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRefH datasource 관련
    const [dataSource2, setDataSource2] = useState<any>(); // gridApiRefL datasource 관련
    const [gridFocus, setGridFocus] = useState(false);
  
    //#endregion
  
    //#region panel 사이즈 관련
    const cd_menu = Menuprops.cd_menu || "SN_SCT_BAS_REG_003";
    const defaultSize = { panel1width: "49.5%", panel2width: "49.5%" };
    const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
    //#endregion

    //#region Initialize
    useEffect(() => {
      const fetchform = async () => {
        setDataSource1([]);
        setDataSource2([]);
        try {
          const rtn: any = await getInitFormData();
          setFormControlData(rtn.formControlData); // 조회조건 항
          setFormData(rtn.formData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2);
        } catch (error) {}
      };
      fetchform();
    }, []);
  
    useEffect(() => {
      gridApiRefH.current.selectAndFocusRow(0);
      setGridFocus(false);
    }, [gridFocus]);
  
    //#region  Button Event
    useImperativeHandle(ref, () => ({
      onSearch,
      onSave,
    }));
  
    //#region OnSearch
    const onSearch = async () => {
      const modifiedRowsH = gridApiRefH.current.getChange();
      const modifiedRowsL = gridApiRefL.current.getChange();
  
      if (
        modifiedRowsH.modifiedRowcount > 0 ||
        modifiedRowsL.modifiedRowcount > 0
      ) {
        const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          await onSave();
        }
      }
      try {
        const params = {
          id: "sn_sct_bas_reg_003_01",
          params: searchRef.current.getFormdata(),
        };
  
        setDataSource1([]);
        setDataSource2([]);
        const data: any = await fnGetDataSet(params);
        setDataSource1(data[0]);
        setDataSource2(data[1]);
  
        if (data[0] && data[0].length > 0) {
          // 1. 그리드 데이터가 바인딩되었음을 기다림
          await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)
          setGridFocus(true);
        }
  
        gridApiRefH.current.resetUpdate();
        gridApiRefL.current.resetUpdate();
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };
  
    //#region  OnSave
    const onSave = async () => {
      try {
        gridApiRefL.current.api.stopEditing();
        const sctBomH = gridApiRefL.current.getChange();
        if (sctBomH.modifiedRowcount === 0) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return;
        }
        const SaveData = {
          sct_bomh: sctBomH,
        };
        await fnSave("SN_SCT_BAS_REG_003_SAVE_01", SaveData);
  
        gridApiRefL.current.resetUpdate();
      } catch (error: any) {}
    };
    //#endregion
  
    //#region Filter
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      if (selectedRow) {
        gridApiRefL.current.applyFilters({ cd_cust: selectedRow.cd_cust });
        gridApiRefL.current.selectAndFocusRow(0);
      } else {
        return;
      }
    };
    //#endregion
  
    //#region  UI
    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            
          ></SearchPanel>
        </div>
        <div className="w-full flex flex-row space-x-2 flex-grow overflow-x-auto">
          <SnResizable
          direction={"width"}
          minHeight={130}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          seq={1}
          size={sizes.panel1width}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          >
            <div className="h-full">
              <SnGrid
                
                seq={1}
                ref={gridApiRefH}
                enableAddRow={true}
                columnConfig={columns1}
                isEditable={false}
                rowData={dataSource1}
                onFocusedRowChanged={onFocusedRowChanged}
                rowSelection="single"
                title="외주처정보"
                resizeController={{
                defaultSize: defaultSize,
                onResizeStop: onResizeStop,
                }}
              />
            </div>
          </SnResizable>
          <SnResizable
          direction={"width"}
          minHeight={130}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          seq={2}
          size={sizes.panel2width}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          >
            <div className="h-full">
              <SnGrid
                
                seq={2}
                ref={gridApiRefL}
                enableAddRow={true}
                isEditable={true}
                columnConfig={columns2}
                rowData={dataSource2}
                rowSelection="single"
                title="외주품정보"
                resizeController={{
                defaultSize: defaultSize,
                onResizeStop: onResizeStop,
               }}
              />
            </div>
          </SnResizable>
        </div>
      </div>
    );
  });
  
  export default SN_SCT_BAS_REG_003;
  